import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {ScheduleUser, ScheduleUserResponse} from 'features/model/types/groups/schedule/scheduleUserSchema';
import {fetchScheduleUsers} from "features/model/service/groups/schedule-dev/fetchScheduleUsers";


interface ScheduleState {
    loading: boolean;
    error: string | null;
    users: ScheduleUser[];
}

const initialState: ScheduleState = {
    loading: false,
    error: null,
    users: [],
};

const scheduleUserSlice = createSlice({
    name: 'schedule',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchScheduleUsers.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchScheduleUsers.fulfilled, (state, action: PayloadAction<ScheduleUserResponse>) => {
                state.loading = false;
                state.error = null;
                state.users = action.payload.users;
            })
            .addCase(fetchScheduleUsers.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});


export const scheduleUserReducer = scheduleUserSlice.reducer;
